import { AdminRequest, AdminRequestInterface } from "../client/AdminRequest";
import { ClientInfoRequest } from "../client/ClientInfoRequest";
import { ClientUpdateRequest } from "../client/ClientUpdateRequest";
import { OpenUrlRequest } from "../client/OpenUrlRequest";

enum AdminRequestType {
    CLIENT_INFO = "CLIENT_INFO",
    OPEN_WEB_URL = "OPEN_WEB_URL",
    WEB_CLIENT_UPDATE = "WEB_CLIENT_UPDATE"
}

export class AdminRequestFactory {
    create(message: AdminRequestInterface): AdminRequest {
        switch (message?.type?.toUpperCase()) {
            case AdminRequestType.CLIENT_INFO:
                return new ClientInfoRequest(message);
            case AdminRequestType.OPEN_WEB_URL:
                return new OpenUrlRequest(message);
            case AdminRequestType.WEB_CLIENT_UPDATE:
                return new ClientUpdateRequest(message);
            default:
                return null;
        }
    }
}
